class CollectionFilters extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.filterTabs = Array.from(this.querySelectorAll("accordion-toggle"));
    this.filterOptions = this.querySelectorAll("input");
    this.minRange = this.querySelector("input[type='range'][data-min-value]");
    this.maxRange = this.querySelector("input[type='range'][data-max-value]");
    this.minValueDisplay = this.querySelector("[data-min-value-display]");
    this.maxValueDisplay = this.querySelector("[data-max-value-display]");

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleRangeInput = this.handleRangeInput.bind(this);

    this.filterOptions.forEach((option) => {
      option.addEventListener("change", this.handleFilterChange);
    });

    this.minRange.addEventListener("input", this.handleRangeInput);
    this.maxRange.addEventListener("input", this.handleRangeInput);

    this.clearButton = this.querySelector(".collection-filter__clear");
    if (this.clearButton) {
      this.clearButton.addEventListener("click", this.handleClearFilters.bind(this));
    }

    this.mobileTrigger = document.querySelector(".collection-filter__button");
    this.overlay = document.querySelector(".collection-filters-overlay");

    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);

    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener("click", this.handleDrawerToggle);
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", this.handleDrawerClose);
    }

    this.closeButton = this.querySelector(".collection-filters__close");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleDrawerClose);
    }

    this.updateColorFilterState();
  }

  disconnectedCallback() {
    this.filterOptions.forEach((option) => {
      option.removeEventListener("change", this.handleFilterChange);
    });

    this.minRange.removeEventListener("input", this.handleRangeInput);
    this.maxRange.removeEventListener("input", this.handleRangeInput);

    if (this.mobileTrigger) {
      this.mobileTrigger.removeEventListener("click", this.handleDrawerToggle);
    }

    if (this.overlay) {
      this.overlay.removeEventListener("click", this.handleDrawerClose);
    }

    this.closeButton = this.querySelector(".collection-filters__close");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleDrawerClose);
    }
  }

  updateColorFilterState() {
    const colorInputs = this.querySelectorAll(
      ".collection-filter__swatch-color input"
    );

    const checked = Array.from(colorInputs).find(input => input.checked);

    colorInputs.forEach(input => {
      const option = input.closest(".collection-filter__swatch-color");

      if (!checked) {
        input.disabled = false;
        option.classList.remove("is-locked");
      } else if (input !== checked) {
        input.disabled = true;
        option.classList.add("is-locked");
      } else {
        input.disabled = false;
        option.classList.remove("is-locked");
      }
    });
  }

  handleFilterChange(event) {
    const input = event.target;
    let url;

    if (input.dataset.addUrl || input.dataset.removeUrl) {
      url = new URL(
        input.checked ? input.dataset.addUrl : input.dataset.removeUrl,
        window.location.origin
      );
    } else {

      url = new URL(location.href);

      url.searchParams.delete(this.minRange.dataset.param);
      url.searchParams.delete(this.maxRange.dataset.param);
      url.searchParams.set(this.minRange.dataset.param, this.minRange.value);
      url.searchParams.set(this.maxRange.dataset.param, this.maxRange.value);
    }

    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        const openFilters = this.filterTabs
          .map((value, index) =>
            value.classList.contains("accordion--open") ? index : -1
          )
          .filter((index) => index !== -1);

        openFilters.forEach((index) => {
          const currentFilter = tempDiv
            .querySelector(".collection-filters__content")
            .querySelectorAll("accordion-toggle")[index];

          currentFilter.classList.add("accordion--open");
        });

        document.querySelector(".collection-inner").innerHTML =
          tempDiv.querySelector(".collection-inner").innerHTML;

        initializeCollectionProductCards();

        url.searchParams.delete("section_id");
        window.history.pushState({}, "", url.toString());
      });
  }

  handleRangeInput(event) {
    // Update display in real-time while dragging
    const value = parseInt(event.currentTarget.value);
    const isMinRange = event.currentTarget.hasAttribute("data-min-value");

    if (isMinRange) {
      // Ensure min value doesn't exceed max value - 1
      const maxValue = parseInt(this.maxRange.value);
      if (value >= maxValue) {
        console.log("max value");
        event.currentTarget.value = maxValue - 10;
      }

      if (this.minValueDisplay) {
        this.minValueDisplay.textContent = this.formatValue(
          event.currentTarget.value,
          event.currentTarget
        );
      }
    } else {
      // Ensure max value doesn't go below min value + 1
      const minValue = parseInt(this.minRange.value);
      if (value <= minValue) {
        event.currentTarget.value = minValue + 10;
      }

      if (this.maxValueDisplay) {
        this.maxValueDisplay.textContent = this.formatValue(
          event.currentTarget.value,
          event.currentTarget
        );
      }
    }
  }

  handleDrawerToggle() {
    this.classList.add("is-open");

    if (this.overlay) {
      this.overlay.classList.add("is-visible");
    }

    document.body.classList.add("overflow-hidden");
  }

  handleDrawerClose() {
    this.classList.remove("is-open");

    if (this.overlay) {
      this.overlay.classList.remove("is-visible");
    }

    document.body.classList.remove("overflow-hidden");
  }

  formatValue(value) {
    // Convert from cents to dollars and format as currency without decimals
    const dollars = value;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(dollars);
  }

  handleClearFilters(event) {
    event.preventDefault();

    const url = new URL(window.location.href);

    // Remove ALL query params (filters, price, sort, etc.)
    url.search = "";

    // Re-apply section rendering
    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        // Replace collection content
        document.querySelector(".collection-inner").innerHTML =
          tempDiv.querySelector(".collection-inner").innerHTML;

        // Re-init cards
        initializeCollectionProductCards();

        // Update URL clean
        window.history.pushState({}, "", window.location.pathname);
      });
  }
}

customElements.define("collection-filters", CollectionFilters);

class CollectionSort extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.select = this.querySelector("#sort-by-select");

    this.handleChange = this.handleChange.bind(this);

    if (this.select) {
      this.select.addEventListener("change", this.handleChange);
    }
  }

  disconnectedCallback() {
    if (this.select) {
      this.select.removeEventListener("change", this.handleChange);
    }
  }

  handleChange(event) {
    const sortBy = event.target.value;

    const url = new URL(window.location.href);

    // Preserve existing filters
    url.searchParams.set("sort_by", sortBy);

    // Fetch section HTML only
    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        // Preserve open accordions
        const currentFilters = document.querySelectorAll(
          ".collection-filters accordion-toggle"
        );

        const openFilters = Array.from(currentFilters)
          .map((value, index) =>
            value.classList.contains("accordion--open") ? index : -1
          )
          .filter((index) => index !== -1);

        openFilters.forEach((index) => {
          const nextFilter = tempDiv
            .querySelector(".collection-filters__content")
            ?.querySelectorAll("accordion-toggle")[index];

          if (nextFilter) {
            nextFilter.classList.add("accordion--open");
          }
        });

        // Replace collection content
        document.querySelector(".collection-inner").innerHTML =
          tempDiv.querySelector(".collection-inner").innerHTML;

        initializeCollectionProductCards();

        // Update browser URL
        url.searchParams.delete("section_id");
        window.history.pushState({}, "", url.toString());
      });
  }
}

customElements.define("collection-sort", CollectionSort);

class AccordionToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.querySelector(".accordion__header");
    this.content = this.querySelector(".accordion__content");

    this.handleClick = this.handleClick.bind(this);

    this.header.addEventListener("click", this.handleClick);

    this.addMaxHeight();
  }

  disconnectedCallback() {
    this.header.removeEventListener("click", this.handleClick);
  }

  handleClick() {
    if (this.classList.contains("accordion--open")) {
      this.classList.remove("accordion--open");
    } else {
      this.classList.add("accordion--open");
    }
  }

  addMaxHeight() {
    this.style.setProperty("--accordion-content-height", this.content.scrollHeight + "px");
  }
}

customElements.define("accordion-toggle", AccordionToggle);

class CollectionProductCard {
  constructor(card) {
    this.card = card;

    this.mainImage = this.card.querySelector(".collection-product__image");
    this.hoverImage = this.card.querySelector(".collection-product__hover-image");

    this.variantIdInput = this.card.querySelector('input[name="id"]');
    this.colorTitle = this.card.querySelector(".collection-product__color-title");

    this.colors = this.card.querySelectorAll(".collection-product__color");

    if (!this.colors.length) return;

    this.handleColorClick = this.handleColorClick.bind(this);

    this.colors.forEach((color) => {
      color.addEventListener("click", this.handleColorClick);
    });

    // Initialize first active color
    const activeColor =
      this.card.querySelector(".collection-product__color.active") ||
      this.colors[0];

    if (activeColor) {
      this.updateImages(activeColor);
    }
  }

  handleColorClick(event) {
    const clickedColor = event.currentTarget;

    this.colors.forEach((color) => {
      color.classList.remove("active");
    });

    clickedColor.classList.add("active");

    this.updateImages(clickedColor);
  }

  updateImages(colorElement) {
    const mainImage = colorElement.dataset.variantImg;
    const hoverImage = colorElement.dataset.variantImgHover;
    const variantId = colorElement.dataset.variantId;
    const variantTitle = colorElement.dataset.variantTitle;

    if (mainImage && this.mainImage) {
      this.mainImage.src = mainImage;
    }

    if (hoverImage && this.hoverImage) {
      this.hoverImage.src = hoverImage;
    }

    if (variantId && this.variantIdInput) {
      this.variantIdInput.value = variantId;
    }

    if (variantTitle && this.colorTitle) {
      this.colorTitle.textContent = variantTitle;
    }
  }

  selectColor(colorHandle) {
    if (!colorHandle) return;

    const target = Array.from(this.colors).find(color =>
      color.dataset.color === colorHandle
    );

    if (!target) return;

    this.colors.forEach(color => color.classList.remove("active"));
    target.classList.add("active");

    this.updateImages(target);
  }
}

function initializeCollectionProductCards(scope = document) {
  // Find selected color filter
  const checkedColor = document.querySelector(
    ".collection-filter__swatch-color input:checked"
  );

  const selectedColor = checkedColor
    ? checkedColor.value
    : null;

  const cards = scope.querySelectorAll("[collection-product-card]");

  cards.forEach(card => {
    if (!card.collectionProductCardInitialized) {
      const productCard = new CollectionProductCard(card);

      if (selectedColor) {
        productCard.selectColor(selectedColor);
      }

      card.collectionProductCardInitialized = true;
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeCollectionProductCards();
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.tags-more-btn');
  if (!btn) return;

  const container = btn.closest('.collection-product__tags');
  const hiddenItems = container.querySelectorAll('.feature-hidden');

  const expanded = btn.dataset.expanded === 'true';

  hiddenItems.forEach(el => {
    el.style.display = expanded ? 'none' : '';
  });

  btn.dataset.expanded = !expanded;
  btn.textContent = expanded ? 'More' : 'Less';
});